import { useEffect, useRef } from 'react';
import COS from 'cos-js-sdk-v5';
// import { getUploadCloudMessage } from '@gp/services/projectDetail';
import { getGPOPTencentQCouldMassage } from '@gp/services/global';
import { ENV } from '@home/_config/config';
import { Base64 } from 'js-base64';
import { COS_BUCKET_NEW } from '@gp/constants/const';
// @ts-ignore
// import { storage } from '@gp/utils/utils.js';
// const DEFAULT_BARKET = 'databrain-test-1300342678';
// const DEFAULT_REGION = 'ap-singapore';
const DURATION = 1 * 60 * 60;

interface PropsType {
  qCouldService?: (params: any) => Promise<any>;
  qCouldServiceParams?: any;
  isUseAccelerate?: boolean;
}

export default function useCos(props: PropsType) {
  // 全球加速，预发布和正式
  const controlledEnv = ['pre', 'pro'];
  const defIsUseAccelerate = controlledEnv.includes(ENV);

  const {
    qCouldService = null,
    qCouldServiceParams = null,
    isUseAccelerate = defIsUseAccelerate,
  } = props || {};

  const cosRef = useRef<any>(null);
  const uploadOptions = useRef<any>(null);

  const putObject = async (params: any): Promise<any> => {
    uploadOptions.current = qCouldService
      ? await qCouldService?.(qCouldServiceParams)
      : await getGPOPTencentQCouldMassage(qCouldServiceParams);
    if (!cosRef.current) return Promise.reject('cos插件未初始化');

    return new Promise((resolve, reject) => {
      const cos = cosRef.current;
      const { path, file, onProgress, onTaskReady } = params || {};

      cos.putObject(
        {
          Bucket: uploadOptions.current?.bucket /* 填入您自己的存储桶，必须字段 */,
          Region: uploadOptions.current?.region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
          Key: path /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
          // BIDS广州存储桶存储类型不确定，不传，不然上传不了
          StorageClass:
            uploadOptions.current?.bucket === COS_BUCKET_NEW ? '' : 'STANDARD',
          Body: file, // 上传文件对象
          onProgress(progressData: any) {
            onProgress instanceof Function && onProgress(progressData);
          },
          onTaskReady(taskId: string) {
            onTaskReady instanceof Function && onTaskReady(taskId);
          },
        },
        (err: any, data: any) => {
          if (err) {
            reject(err);
          } else {
            resolve(data);
          }
        },
      );
    });
  };

  const putObjects = async (params: any[]): Promise<any[]> => {
    if (!Array.isArray(params)) throw new Error('批量上传参数异常');
    try {
      const promises = params?.map((item) => putObject(item));
      const results: any[] = await Promise.allSettled(promises);
      if (results?.length && results.every((item) => item.status === 'rejected')) {
        throw new Error(results[0].reason);
      }
      return results;
    } catch (e) {
      throw e;
    }
  };

  const getObjectUrl = async (params: any): Promise<any> => {
    if (!uploadOptions.current)
      uploadOptions.current = qCouldService
        ? await qCouldService?.(qCouldServiceParams)
        : await getGPOPTencentQCouldMassage(qCouldServiceParams);
    if (!cosRef.current) return Promise.reject('cos插件未初始化');

    return new Promise((resolve, reject) => {
      const cos = cosRef.current;
      const { path } = params || {};

      cos.getObjectUrl(
        {
          Bucket: uploadOptions.current?.bucket /* 填入您自己的存储桶，必须字段 */,
          Region: uploadOptions.current?.region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
          Key: path /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
          Expires: 60 * 60 * 24 * 365 * 5 /* 签名几秒后失效，默认900秒，这里设置成5年有效时间 */,
          Sign: true /* 获取带签名的对象URL，因为url权限是私有的，不带签名获取是拒绝访问的，带签名获取的话签名是有过期时间的 */,
        },
        (err: any, data: any) => {
          if (err) {
            reject(err);
            return;
          }
          /* url为对象访问url */
          const url = data.Url;
          /* 复制downloadUrl的值到浏览器打开会自动触发下载 */
          const downloadUrl = `${
            url + (url.indexOf('?') > -1 ? '&' : '?')
          }response-content-disposition=attachment`; // 补充强制下载的参数
          resolve({ url, downloadUrl });
        },
      );
    });
  };

  /**
   * 获取图片预览链接
   * @param params 获取图片预览链接的参数
   * @returns 图片预览链接
   */
  const getImagePreviewUrlNew = async (params: { path: string; }) => {
    if (!uploadOptions.current)
      uploadOptions.current = qCouldService
        ? await qCouldService?.(qCouldServiceParams)
        : await getGPOPTencentQCouldMassage(qCouldServiceParams);
    if (!cosRef.current) return Promise.reject('cos插件未初始化222');

    const userName = sessionStorage.getItem('userName');
    if (!userName) throw new Error('can not preview document without username watermark');

    let { url } = await getObjectUrl(params);
    const watermarkConfig = `watermark/2/text/${Base64.encodeURI(
      userName,
    )}/fontsize/20/fill/${Base64.encodeURI(
      '#C0C0C0',
    )}/dissolve/60/dx/50/dy/100/batch/1/spacing/50/degree/315`;
    if (url?.includes('?')) {
      url = `${url}&${watermarkConfig}`;
    } else {
      url = `${url}?${watermarkConfig}`;
    }
    return { url };
  };

  const getObjectsUrl = async (params: any[]): Promise<any[]> => {
    if (!cosRef.current) return Promise.reject('cos插件未初始化');

    if (!Array.isArray(params)) throw new Error('批量获取对象访问url参数异常');
    try {
      const promises = params?.map((item) => getObjectUrl(item));
      const results: any[] = await Promise.allSettled(promises);
      if (results?.length && results.every((item) => item.status === 'rejected')) {
        throw new Error(results[0].reason);
      }
      return results;
    } catch (e) {
      throw e;
    }
  };

  const deleteObject = async (params: any): Promise<any> => {
    uploadOptions.current = qCouldService
      ? await qCouldService?.(qCouldServiceParams)
      : await getGPOPTencentQCouldMassage(qCouldServiceParams);
    if (!cosRef.current) return Promise.reject('cos插件未初始化');

    return new Promise((resolve, reject) => {
      const cos = cosRef.current;
      const { path } = params;

      cos.deleteObject(
        {
          Bucket: uploadOptions.current?.bucket /* 填入您自己的存储桶，必须字段 */,
          Region: uploadOptions.current?.region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
          Key: path /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
        },
        (err: any, data: any) => {
          if (err) {
            reject(err);
            return;
          }
          resolve(data);
        },
      );
    });
  };

  const getBucket = async (params?: any): Promise<any> => {
    if (!cosRef.current) return Promise.reject('cos插件未初始化');
    if (!uploadOptions.current) {
      uploadOptions.current = qCouldService
        ? await qCouldService?.(qCouldServiceParams)
        : await getGPOPTencentQCouldMassage(qCouldServiceParams);
    }

    return new Promise((resolve, reject) => {
      const cos = cosRef.current;
      const { prefix = '' } = params || {};
      cos.getBucket(
        {
          Bucket: uploadOptions.current?.bucket /* 填入您自己的存储桶，必须字段 */,
          Region: uploadOptions.current?.region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
          Prefix: prefix /* Prefix表示列出的object的key以prefix开始，非必须 */,
        },
        (err: any, data: any) => {
          if (err) {
            reject(err);
            return;
          }
          resolve(data);
        },
      );
    });
  };

  // 取消上传中任务，实际使用没啥用，取消不了
  const cancelTask = async (taskId: string) => {
    if (!cosRef.current) return Promise.reject('cos插件未初始化');

    const cos = cosRef.current;
    cos.cancelTask(taskId);
  };

  const updateAuthorization = async () => {
    uploadOptions.current = qCouldService
      ? await qCouldService?.(qCouldServiceParams)
      : await getGPOPTencentQCouldMassage(qCouldServiceParams);
  };

  useEffect(() => {
    cosRef.current = new COS({
      // 指定 true，使用全球加速域名请求
      UseAccelerate: isUseAccelerate,
      async getAuthorization(options: any, callback: Function) {
        // 异步获取临时密钥
        // 服务端 JS 和 PHP 例子：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
        // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
        // STS 详细文档指引看：https://cloud.tencent.com/document/product/436/14048
        const res: any = uploadOptions.current
          ? uploadOptions.current
          : qCouldService
            ? await qCouldService?.(qCouldServiceParams)
            : await getGPOPTencentQCouldMassage(qCouldServiceParams);
        const startTime = Math.floor(Date.now() / 1000);
        const endTime = Math.floor(startTime + DURATION - 1 * 60);
        callback({
          TmpSecretId: res?.tmp_secret_id || '',
          TmpSecretKey: res?.tmp_secret_key || '',
          SecurityToken: res?.session_token || '',
          // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
          StartTime: startTime, // 时间戳，单位秒，如：1580000000
          ExpiredTime: endTime, // 时间戳，单位秒，如：1580000000
        });
      },
    });
  }, []);

  return {
    cosRef,
    getBucket,
    putObject,
    putObjects,
    getObjectUrl,
    getObjectsUrl,
    deleteObject,
    cancelTask,
    updateAuthorization,
    getImagePreviewUrlNew,
  };
}
